import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-apply-now-header',
  templateUrl: './apply-now-header.component.html',
  styleUrls: ['./apply-now-header.component.scss']
})
export class ApplyNowHeaderComponent implements OnInit {

  @Input() hideSection = false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/apply-now-header/apply-now-header.component.ts